import React from 'react'
import { CateArry } from '../constants/index'
import {Foot} from '../constants/index'
import SecondCent from '../assests/SecondCent.png'
import Fan from '../assests/Fan.png'
import SolarBoard from '../assests/SolarBoard.png'
import Add from '../assests/Add.png'
import navdbg from '../assests/navdbg.png'
function Category() {
  return (
    <section className='w-full h-[790px] bg-slate-700 relative -z-10 '>
    <div className='absolute -z-10 bottom-0 right-0'><img src={navdbg} alt='nav down' className='items-end'/></div>
    <div className='relative full h-[240px] bg-[#AE0243] -z-10 rounded-b-2xl'>
         <img src={Fan} alt='virual' className='ml-[50%]  absolute z-20'/>
         <img src={SolarBoard} alt='virual' className='ml-[50%] absolute z-20 pt-[30%]'/>
         <img src={SecondCent} alt='second' className='w-36 h-36 relative top-4  pl-6 '/>
     <div className='w-[200px] h-16 relative mt-[2%] ml-14 text-white '>
     <p> Dec 12-14, 2024</p>
    <p>OCEC Muscat, Oman</p>
     </div>
    </div>
   
    
        <div className='w-[249px] h-[350px] pt-8 mx-auto grid grid-cols-3 gap-12'>
          
          {
            CateArry.map((cimg)=>(
            <div className=''>
            <img src={cimg.Cimg} alt='category'/>
            <h5 className='mt-3 -ml-3 w-32 text-white font-semibold text-left'>{cimg.txt}</h5>
          </div>
          ))
          }
        </div>
        

        <div className='w-full h-[93px] pt-16 '>
           <img src={Add} alt='add' className='mx-auto'/>
       </div>
    
        <div className='w-full rounded-t-2xl grid grid-cols-5 absolute z-10 bg-white mt-24 '>
    {
        
      Foot.map((fot,i)=>(
        <div className='w-full h-16 ml-10 bg-white pt-6'>
           <img src={fot.im} alt='footer' className='w-[39px] h-[30px] ml-4  '/>
     </div>
      ))  
      
    }
    </div>

    </section>
  )
}

export default Category
